import React, { useState } from 'react';
import axios from 'axiosInstance';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import '../css/AuthLogin.css'; 
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

const ContraseñaOlvidada = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState({ text: '', variant: '' });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
   const GoLogin = () => {
    navigate('/login'); 
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ text: '', variant: '' });
    setIsLoading(true);


   

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_URL + '/api/auth/forgotten-password',
        { email },
        { headers: { 'Content-Type': 'application/json' } }
      );

      
      if (response.status === 204) {
        setMessage({
          text: 'Si ese correo está registrado, recibirás un email para recuperar tu contraseña.',
          variant: 'info',
        });
      } else {
        setMessage({
          text: 'Correo para recuperar contraseña enviado con éxito. Revisa tu bandeja de entrada.',
          variant: 'success',
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setMessage({
          text: 'Ya hay una solicitud de recuperación de contraseña en curso para este email.',
          variant: 'warning',
        });
      } else {
        setMessage({
          text: 'Error al procesar la solicitud, inténtalo más tarde.',
          variant: 'danger',
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    
    <Container style={{ maxWidth: '700px' }} className="mt-5">
      <Button className="boton_accion" size="sm" onClick={GoLogin}>⬅ volver</Button>
      <h2 className="Titulo">Recuperar contraseña</h2>
     

      {message.text && <Alert variant={message.variant}>{message.text}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="formEmail">
          <Form.Label>Correo Gmail</Form.Label>
          <Form.Control
            type="email"
            placeholder="tuemail@gmail.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group>

        <Button
          
          type="submit"
          disabled={isLoading}
          className="boton_accion_user w-100"
        >
          {isLoading ? 'Enviando...' : 'Enviar correo de recuperación'}
        </Button>
      </Form>
    </Container>
  );
};

export default ContraseñaOlvidada;
